
import React from 'react'

// Redux
import { connect } from 'react-redux';
  

const Alert = ({ 
    alerts
}) => {

    return (
        // Check if alerts exist and has items
        <div style={{minHeight: '60px', marginBottom: '10px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <div className={`alert ${alerts[alerts.length - 1]?.alertType === 'success' ? 'sucess' : ''}`} style={{display: `${alerts?.length > 0 ? 'block' : 'none'}`}}>
                {alerts?.length > 0 && (
                    <p className="alert-title">{alerts[alerts.length - 1].msg}</p>
                )}
            </div>
        </div>
    )
}

// Define the props that will be passed into the component
const mapStateToProps = (state) => ({
    alerts: state.alert,
});

export default connect(mapStateToProps, null)(Alert);